import { Document, DocumentType } from '@pelicargo/types';

export const getMissingDocumentTypes = (documents: Partial<Document>[], documentTypes: DocumentType[]) => {
  const missingDocumentTypes = documentTypes.filter(
    (type) => !documents?.some((doc: Partial<Document>) => doc?.type === type),
  );
  return missingDocumentTypes;
};

/**
 * Takes in a string and mutates it to be a valid slug.
 *
 * 1. To local lowercase (and translate any valid special characters i.e. & to and, é to e, etc.)
 * 2. Strip of any remaining special characters
 * 3. Replace multiple spaces with one
 * 4. Replace spaces with underscores
 */
export const slugify = (input: string) => {
  const normalized = (input ?? '')
    .toLocaleLowerCase()
    .replace(/&/g, ' and ')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9_\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return normalized.replace(/\s/g, '-');
};
